import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { FAQ } from "../components/FAQ";
import { Form } from "../components/Form";
import entrenamiento from "../assets/entrenamiento.jpeg";
import viaje from "../assets/viaje.jpeg";
import reporte from "../assets/reporte.jpeg";
import Loqueviviras from "../components/Loqueviviras";
import ContadorAnimado from "../components/ContadorAnimado";
import { ModalRegistro } from "../components/ModalRegistro";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as bootstrap from "bootstrap";

import {
  FaCampground,
  FaBible,
  FaHandsHelping,
  FaUsers,
  FaArrowRight,
} from "react-icons/fa";

export default function BootCamp() {

  const irPreguntasFrecuentes = () => {
    const seccion = document.getElementById("preguntas-frecuentes");

    if (seccion) {
      seccion.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const [mostrarRegistro, setMostrarRegistro] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/bootcamp/registro") {
      setMostrarRegistro(true);
    } else {
      setMostrarRegistro(false);
    }
  }, [location.pathname]);


  return (
    <>
      {/* HERO */}
      <section
        className="text-white d-flex align-items-center"
        style={{
          minHeight: "120vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,.55), rgba(61,16,66,.70)), url('https://thumbs-us-east-1.myalbum.io/photo/1k0/6221a7c8-89a0-439b-94d4-9a12f32ba52b.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginTop: "100px",
        }}
      >
        {" "}
        <div className="container text-center">
          <span
            className="badge px-4 py-2 mb-3"
            style={{
              background: "linear-gradient(135deg,#9b2a92,#3d1042)",
            }}
          ></span>
          <br></br>
          <br></br>
          <h1 className="display-2 fw-bold titulos-secciones">Boot Camp</h1>

          <p className="lead mt-3 mx-auto" style={{ maxWidth: "800px" }}>
            Un entrenamiento intensivo diseñado para preparar jóvenes física,
            espiritual y emocionalmente para servir en las misiones y proyectos
            de impacto.
          </p>

          <button
            className="btn btn-participar btn-lg text-white rounded-pill px-5 mt-3"
            style={{
              background: "linear-gradient(135deg,#70f570,#49c628)",
              border: "none",
              fontSize: "1.4rem",
              fontFamily: "sans-serif",
            }}
            data-bs-toggle="modal"
            data-bs-target="#registroModal"
            type="button"
            onClick={() => navigate("/bootcamp/registro")}
          >
            PARTICIPA
          </button>
        </div>
      </section>

      {/* INTRODUCCIÓN */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="d-flex justify-content-center">
              <img
                src="https://thumbs-us-east-1.myalbum.io/photo/1k0/34dba551-cef7-4395-97c4-d301dcb82c1f.jpg"
                alt="Boot Camp"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  maxWidth: "90%",
                  border: "4px solid rgba(255,255,255,0.85)",
                  boxShadow: "0 15px 35px rgba(0,0,0,0.25)",
                }}
              />
            </div>
            {/*
        <div className="col-lg-6">

          <h2
            className="fw-bold mb-4"
            style={{ color: "#3d1042" }}
          >
            ¿Qué es el Boot Camp?
          </h2>

          <p className="lead">
            Es una experiencia intensiva donde los participantes
            desarrollan disciplina, liderazgo, trabajo en equipo
            y una profunda relación con Dios.
          </p>

          <p>
            Durante varios días los jóvenes reciben capacitación
            bíblica, actividades prácticas, servicio comunitario,
            evangelismo y entrenamiento misionero.
          </p>

        </div>
     */}
          </div>
        </div>
      </section>

      <section className="p-0 m-0">
        <div className="container-fluid px-0">
          <img
            src="https://thumbs-us-east-1.myalbum.io/photo/1k0/4fbeae77-8ab6-4cbc-ab31-70877404c423.jpg"
            alt="Boot Camp"
            className="img-fluid w-100"
            style={{
              height: "auto",
              backgroundImage:
                "linear-gradient(rgba(0,0,0,.55), rgba(61,16,66,.70))",
            }}
          />
        </div>
      </section>
      {/* ÁREAS */}
      <section
        className="pt-0 pb-5 m-0"
        style={{
          background: "linear-gradient(135deg,#4f2876,#3d1042)",
          minHeight: "95vh",
        }}
      >
        <div className="container-fluid px-0">
          {/* TÍTULO */}
          <h2
            className="text-center text-white fw-bold"
            style={{
              paddingTop: "60px",
              marginBottom: "40px",
            }}
          >
            Etapas del Programa
          </h2>

          {/* TARJETAS */}
          <div className="row g-3 px-2">
            {/* ENTRENAMIENTO */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-valor">
                <img src={entrenamiento} alt="Entrenamiento" />

                <div className="card-valor-overlay">
                  <h5>ENTRENAMIENTO</h5>

                  <p>
                    Tu equipo pasará 11 días en Yangas-Canta, provincia de Lima,
                    en nuestro campo de entrenamiento participando de nuestro
                    programa de simulación para proyectos misioneros para el
                    exterior e interior del país.
                  </p>
                </div>
              </div>
            </div>

            {/* VIAJE */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-valor">
                <img src={viaje} alt="Viaje" />

                <div className="card-valor-overlay">
                  <h5>VIAJE</h5>

                  <p>
                    Tu equipo viajará al lugar donde se desarrollará su práctica
                    misionera sirviendo a través de proyectos de evangelismo y
                    construcción, proclamando el Evangelio a niños y adultos.
                  </p>
                </div>
              </div>
            </div>

            {/* REPORTE */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-valor">
                <img src={reporte} alt="Reporte" />

                <div className="card-valor-overlay">
                  <h5>REPORTE</h5>

                  <p>
                    Después de tu proyecto sirviendo a Jesús con tu equipo,
                    participarás en una reunión para reflexionar sobre las
                    experiencias adquiridas y cómo aplicarlas en tu hogar y tu
                    iglesia para despedirnos de forma significativa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EXPERIENCIA */}

      <Loqueviviras />

      {/* IMPACTO */}

      <section
        className="py-5 text-white espacio-contador"
        style={{
          background: "linear-gradient(135deg,#4f2876,#3d1042)",
          fontSize: "1.8rem",
        }}
      >
        <div className="container text-center">
          <h2 className="fw-bold mb-3">Nuestro Impacto</h2>

          <div className="row">
            <div className="col-md-4">
              <ContadorAnimado numero={2} />
              <p>Campamentos</p>
            </div>

            <div className="col-md-4">
              <ContadorAnimado numero={8} />
              <p>Equipos</p>
            </div>

            <div className="col-md-4">
              <ContadorAnimado numero={90} />
              <p>Campistas</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-0">
        <div className="container-fluid px-0">
          <FAQ />
        </div>
      </section>

      <section className="py-0">
        <div className="container-fluid px-0">
          <Form />
        </div>
      </section>

      <ModalRegistro
        show={mostrarRegistro}
        onClose={() => {
          setMostrarRegistro(false);

          if (location.pathname === "/bootcamp/registro") {
            navigate("/bootcamp");
          }
        }}
      />
    </>
  );
}
